var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpandIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "o"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.33333 0.3125H3.66667C1.8175 0.3125 0.3125 1.8175 0.3125 3.66667V8.33333C0.3125 10.1825 1.8175 11.6875 3.66667 11.6875H8.33333C10.1825 11.6875 11.6875 10.1825 11.6875 8.33333V3.66667C11.6875 1.8175 10.1825 0.3125 8.33333 0.3125ZM10.8125 8.33333C10.8125 9.69833 9.69833 10.8125 8.33333 10.8125H3.66667C2.30167 10.8125 1.1875 9.69833 1.1875 8.33333V3.66667C1.1875 2.30167 2.30167 1.1875 3.66667 1.1875H8.33333C9.69833 1.1875 10.8125 2.30167 10.8125 3.66667V8.33333Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3078 2.62833C6.2203 2.54083 6.10946 2.5 5.99863 2.5C5.8878 2.5 5.77696 2.54083 5.68946 2.62833L3.35613 4.96167C3.18696 5.13083 3.18696 5.41083 3.35613 5.58C3.5253 5.74917 3.8053 5.74917 3.97446 5.58L5.99717 3.66663L8.0228 5.58C8.19196 5.74917 8.47196 5.74917 8.64113 5.58C8.8103 5.41083 8.8103 5.13083 8.64113 4.96167L6.3078 2.62833Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.68946 9.66184C5.77696 9.74934 5.88779 9.79017 5.99862 9.79017C6.10946 9.79017 6.22029 9.74934 6.30779 9.66184L8.64112 7.32851C8.81029 7.15934 8.81029 6.87934 8.64112 6.71017C8.47196 6.54101 8.19196 6.54101 8.02279 6.71017L6.00008 8.62354L3.97446 6.71017C3.80529 6.54101 3.52529 6.54101 3.35612 6.71017C3.18696 6.87934 3.18696 7.15934 3.35612 7.32851L5.68946 9.66184Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandIcon);
export default __webpack_public_path__ + "static/media/expand-icon.0b310502bb9ecace7069662dd22f85dc.svg";
export { ForwardRef as ReactComponent };